import { ua } from '../../../../util/user-agent';
import Clipboard from 'clipboard';

export class Controller {

    /** @ngInject */
    constructor(SharedSsoFactory,Alert,$scope,PasswordManagers,$timeout) {
        this.SharedSsoFactory = SharedSsoFactory;
        this.PasswordManagers = PasswordManagers;
        this.Alert = Alert;
        this.$scope = $scope;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.showIEText = false;
        this.showExtensionAlert = false;
        this.oldExtensionInstalled =
            !!document.getElementById('extension-is-installed-v2.0.1');
        this.hasPass = false;
        this.showPassword = false;
        this.mustRenewOtp=false;
        new Clipboard(".copyCli").on('success', () => {
            this.$scope.$apply(()=>{
                this.Alert('success', 'global.data_copied')
            })
        })
    }

    isComputerAdministrationAccount(account) {
        return account.publicService.serviceName == 'ComputerLocalAccountAdministration';
    }


    copyCli(p){
        this.getPassword(p);
    }

    getPassword(p) {
        return this.PasswordManagers.getCorporatePassword(p.id).then((data)=>{
            if(data.password){
                p.password = data.password;
               // p.hiddenPass = true;
                p.hasPass = true;
            }
            else
                p.noPassword=true;
        })
    };

    getOtp(p) {
        return this.PasswordManagers.getCorporateOtp(p.id)
            .then((data)=>{p.otp = data.otp;})
            .then(()=>this.$timeout(30000))
            .then(()=>p.mustRenewOtp=true);
    };
    renewOTP(p){
        return this.PasswordManagers.getCorporateOtp(p.id)
            .then((data)=>{p.otp = data.otp;})
            .then(()=>p.mustRenewOtp=false)
            .then(()=>this.$timeout(30000))
            .then(()=>p.mustRenewOtp=true);
    }

    showPasswordF(p){
	debugger;
		if(p.hiddenPass== undefined || p.hiddenPass==null){
			p.hiddenPass=false;
		}
        p.hiddenPass = p.hiddenPass === false;
        if (this.isComputerAdministrationAccount(p) && p.hiddenPass == false) {
            p.password = null;
            p.hasPass = false;
        }
    }

    ssoLogin(sharedAccount) {
        this.SharedSsoFactory.authenticatorsSSO(sharedAccount);

        const isExtensionInstalled =
            !!document.getElementById("saaspass-extension-info") ||
            !!document.getElementById('extension-is-installed-v2.0.1') ||
            !!document.getElementById('extension-is-installed-v2.1.0');

        if (!isExtensionInstalled) {
            this.showExtensionAlert = true;
            this.showIEText = !(
                ua.isChrome() ||
                ua.isOpera() ||
                ua.isFirefox() ||
                ua.isSafari()
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.controller.js